import Lara from "@/presets/lara";

const baseCheckboxPt = Lara.checkbox;
const baseInputSwitchPt = Lara.inputswitch;
const baseMultiselectPT = Lara.multiselect;

const customCheckboxPt = {
  ...baseCheckboxPt,
  box: ({ context }) => {
    return {
      class: [
        "flex items-center justify-center w-6 h-6 rounded-none transition-colors duration-200",
        "border border-black",
        {
          "bg-black text-white": context.checked,
          "bg-white text-black": !context.checked,
        },
      ],
    };
  },
};

export const programsFilterModalPresets = {
  multiselect: {
    root: (options) => {
      const baseRoot = baseMultiselectPT.root(options);
      const filteredClasses = baseRoot.class.filter((element) => {
        if (typeof element !== "object" || element === null) return true;
        const keys = Object.keys(element);
        return !keys.some((key) => key.includes("hover:border-primary-500") || key.includes("ring-primary"));
      });
      return [filteredClasses, "w-full hover:border-gray-300"];
    },
    panel: {
      class: "border border-gray-300 rounded-md bg-white",
    },
    label: (options) => {
      const baseLabel = baseMultiselectPT.label(options);
      return [baseLabel.class, "!text-gray-500 !placeholder:text-gray-400"];
    },
    trigger: {
      class: [baseMultiselectPT.trigger.class, "!text-gray-400"],
    },
    header: {
      class: "flex items-center p-3 gap-2",
    },
    item: ({ context }) => ({
      class: [
        "flex items-center p-3 gap-2 text-sm",
        {
          "hover:bg-teal-light": !context.selected,
          "hover:bg-university-accentPrimary": context.selected,
        },
      ],
    }),
    filterinput: {
      class: [baseMultiselectPT.filterinput.class, "!border-black"],
    },
    token: {
      class: [baseMultiselectPT.token.class, "!bg-blue-300 !text-university-primary"],
    },
    headercheckbox: customCheckboxPt,
    itemcheckbox: customCheckboxPt,
  },

  inputswitch: {
    ...baseInputSwitchPt,
    slider: (options) => {
      const baseSlider = baseInputSwitchPt.slider(options);
      return [
        baseSlider.class,
        {
          "!bg-gray-300": !options.context.checked,
          "!bg-blue-700": options.context.checked,
        },
      ];
    },
  },
};
